import Vue from 'vue';
import Router from 'vue-router';
import index from "@/views/index";
import login from '@/views/login/login';
import home from "@/views/home/home";

// 车辆管理模块
import carInfo from "@/views/carAdmin/carInfo"; //车辆基本信息
import carTechnology from "@/views/carAdmin/carTechnology"; //车辆技术档案
import maintainRecord from '@/views/carAdmin/maintainRecord'; //维修档案
import maintenancePlan from '@/views/carAdmin/maintenancePlan'; //维护计划

// 工单管理模块
import workOrder_Admin from '@/views/workOrder_Admin/workOrder_Admin';

// 工单审核模块
import workOrder_Audit from '@/views/workOrder_Audit/workOrder_Audit';

// 意见反馈模块
import feedback from '@/views/feedback/feedback';

// 审批管理 
import approve_Set from '@/views/approve_Admin/approve_Set';
import approve_Flow from '@/views/approve_Admin/approve_Flow';

// 日志管理 
import log_Admin from '@/views/log_Admin/log_Admin';

// 企业管理
import company_Admin from '@/views/company_Admin/company_Admin';

// 用户管理
import user_Admin from '@/views/user_Admin/user_Admin';
import role_Admin from '@/views/user_Admin/role_Admin';
import register_Admin from '@/views/user_Admin/register_Admin';

// 消息通知
import messagePage from '@/views/messagePage/messagePage';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: '登录',
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }

    }, {
      path: '',
      name: '',
      component: index,
      children: [{
        path: '/home',
        name: '首页',
        component: home,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/workOrder_Admin',
        name: '工单管理',
        component: workOrder_Admin,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/workOrder_Audit',
        name: '工单审核',
        component: workOrder_Audit,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/feedback',
        name: '意见反馈',
        component: feedback,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/approve_Set',
        name: '审批设置',
        component: approve_Set,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/approve_Flow',
        name: '审批流程',
        component: approve_Flow,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/log_Admin',
        name: '日志管理',
        component: log_Admin,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/company_Admin',
        name: '企业管理',
        component: company_Admin,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/role_Admin',
        name: '角色管理',
        component: role_Admin,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/register_Admin',
        name: '注册管理',
        component: register_Admin,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/user_Admin',
        name: '用户管理',
        component: user_Admin,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/messagePage',
        name: '消息通知',
        component: messagePage,
        meta: {
          requireAuth: true
        }
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js